/**
 * A country.
 *
 * @property {string} countryCode                       - The phone country code.
 * @property {[federalStatePropType]} federalStates     - An array of federal states that partition this country.
 * @property {string} isoCode                           - The ISO-3166-1 alpha-2 code of the country.
 * @property {string} stringCode                        - The translation key for the country name.
 */
export class Country {
    /**
     * Creates a new country.
     * @param {string} countryCode                      - The phone country code.
     * @param {[federalStatePropType]} federalStates    - An array of federal states that partition this country.
     * @param {string} isoCode                          - The ISO-3166-1 alpha-2 code of the country.
     * @param {string} stringCode                       - The translation key for the country name.
     */
    constructor(countryCode, federalStates, isoCode, stringCode) {
        this.countryCode = countryCode
        this.federalStates = federalStates
        this.isoCode = isoCode
        this.stringCode = stringCode
    }
}
